export default __webpack_public_path__ + "static/why-choose-us-cc2e62a6dda46837d2e718128cb6d29a.jpg";